export default __webpack_public_path__ + "static/bear-bg-aa6e11d3d059f01392b6521fab663de0.jpg";